export enum BackgroundTaskStatus {
	Sleeping = "Sleeping",
	Running = "Running",
	Failed = "Failed",
	Cancelled = "Cancelled",
	Success = "Success"
}